import React, { useCallback, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import KitplaySettingSavePage from '@components/common/page/kitplaySetting/KitplaySettingSavePage';
import apiConfig from '@constants/apiConfig';
import useAuth from '@hooks/useAuth';
import useRestaurant from '@hooks/useRestaurant';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { validatePermission } from '@utils';
import { getData, setData } from '@utils/localStorage';
import { Modal, Tabs } from 'antd';

import Device from './tabs/Device';
import GroupArea from './tabs/GroupArea';
import GroupDevice from './tabs/GroupDevice';

const KitplayDeviceTabPage = () => {
    const translate = useTranslate();
    const groupDeviceRef = useRef(null);
    const { permissions } = useAuth();
    const { restaurant } = useRestaurant(); 
    const { restaurantId } = useParams();

    const currentRestaurant = Array.isArray(restaurant) 
        ? restaurant.find(item => String(item.id) === String(restaurantId))
        : null;

    const piServer = currentRestaurant?.piServer || null;
   
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = getData(routes.listKitplaySettingsPage.keyActiveTab);
        return savedTab || 'area';
    });
    const [groupDeviceDirty, setGroupDeviceDirty] = useState(false);
   
    const confirmIfDirty = useCallback((action, contentMessage) => {
        if (groupDeviceDirty && validatePermission([apiConfig.printerGroup.updateWait.baseURL], permissions)) {
            Modal.confirm({
                title: translate.formatMessage(commonMessage.unsavedChangesContent),
                content: contentMessage || '',
                okText: translate.formatMessage(commonMessage.continue),
                cancelText: translate.formatMessage(commonMessage.cancel),
                centered: true,
                onOk: () => {
                    setGroupDeviceDirty(false);
                    action();
                },
            });
        } else {
            action();
        }
    }, [groupDeviceDirty]);
   

    return (
        <PageWrapper routes={[ { breadcrumbName: translate.formatMessage(commonMessage.kitplaySettings) } ]}>
            <ListPage
                baseTable={
                    <>
                        <Tabs
                            type="card"
                            destroyInactiveTabPane
                            onTabClick={(key) => {
                                if (key === activeTab) return;
                                confirmIfDirty(() => {
                                    setActiveTab(key);
                                    setData(routes.deviceTabsRestaurantListPage.keyActiveTab, key);
                                }, translate.formatMessage(commonMessage.unsavedSwitchTab));
                            }}
                            activeKey={activeTab}
                            items={[
                                {
                                    key: 'area',
                                    label: translate.formatMessage(commonMessage.area),
                                    children: <GroupArea piServer={piServer}/>,
                                },
                                {
                                    key: 'device',
                                    label: translate.formatMessage(commonMessage.childDevice),
                                    children: <Device piServer={piServer}/>,
                                },
                                {
                                    key: 'group-device',
                                    label: translate.formatMessage(commonMessage.workflow),
                                    children: (
                                        <GroupDevice ref={groupDeviceRef} onDirtyChange={setGroupDeviceDirty} piServer={piServer}/>
                                    ),
                                },
                                {
                                    key: 'setting-device',
                                    label: translate.formatMessage(commonMessage.setting),
                                    children: <KitplaySettingSavePage deviceId={piServer?.id}/>,
                                },
                            ]}
                        />
                    </>
                }
            />
        </PageWrapper>
    );
};

export default KitplayDeviceTabPage;
